import api from '../api'
import { FileReport, ReportType } from './types'

export const reportFileApi = api.injectEndpoints({
  endpoints: build => ({
    getReportFiles: build.query<FileReport[], { type: ReportType }>({
      query: params => ({
        url: `/web/report_file_list/`,
        cache: 'no-cache',
        params,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
})

export { ReportType } from './types'
